export default __webpack_public_path__ + "static/media/save.6ce8745a.svg";